import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../business';
const RequireAuth = ({ children }) => {
    // const { token } = useAuth();
    const token = useAuthStore((state) => state.token);
    const currentLocation = useLocation();
    if (!token)
        return _jsx(Navigate, { to: "login", state: currentLocation, replace: true });
    return _jsx(_Fragment, { children: children });
};
export { RequireAuth };
